import React, { useCallback, useEffect, useState } from "react";
import { AuthProvider, useAuth } from "react-oidc-context";
import { UserManager } from "oidc-client-ts";
import { useIntl } from "react-intl";

import SignIn from "../signIn";
import config from "../../config";
import { signIn } from "../../modules/session";
import { Token } from "../../modules/httpFunctions";
import { success } from "../../modules/messages";

let KEYCLOAK_CONFIG = {
  clientId: "wa-portal",
  //clientId: "wa-portal-dev",
  url: "https://webapp.cz.dhl.com/kc/realms/public",
};

let userManager = new UserManager({
  authority: KEYCLOAK_CONFIG.url,
  client_id: KEYCLOAK_CONFIG.clientId,
  //redirect_uri: config.WA_URL.slice(0, -1),
  redirect_uri: config.WA_URL + "login",
  post_logout_redirect_uri: config.WA_URL,
});

function LoginChild({ loading, onSetLoading }) {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated && !window.location.search) {
      onSetLoading(true);
      auth
        .signinRedirect()
        .then(() => onSetLoading())
        .catch(() => onSetLoading());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  return <SignIn masterLoading={loading} />;
}

function Login() {
  const intl = useIntl();
  const [loading, setLoading] = useState();

  const handleLogin = useCallback(
    (response) => {
      setLoading(true);
      if (response && response["access_token"]) {
        Token.value = response["access_token"];
        signIn(undefined).then((result) => {
          Token.value = "";
          result.success &&
            success(
              intl.formatMessage({
                id: "user.successfulLogin",
                defaultMessage: "Došlo k úspěšnému přihlášení.",
              })
            );
        });
      }
      setLoading(false);
    },
    [intl]
  );

  return (
    <AuthProvider
      userManager={userManager}
      onSigninCallback={(response) => {
        handleLogin(response);
        window.history.pushState({}, document.title, window.location.pathname);
      }}
    >
      <LoginChild loading={loading} onSetLoading={setLoading} />
    </AuthProvider>
  );
}

export default Login;
